(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory("InterceptorEnum", interceptorEnumFactory);

  function interceptorEnumFactory() {
    var disallowedStrings = Object.freeze({
      LOGIN: "/emailSignIn",
      PASSWORD_RESET: "/passwordReset",
      REFRESH_TOKEN: "/refreshToken"
    });

    var allowedStrings = Object.freeze({
      API: "/api/"
    });

    function isStringValid(urlString) {
      var disallowedArray = Object.keys(disallowedStrings);

      for (var i = 0; i < disallowedArray.length; i++) {
        var string = disallowedStrings[disallowedArray[i]];
        if (urlString.indexOf(string) !== -1) {
          return false;
        }
      }
      return true;
    }

    function isApiCall(urlString) {
      if (urlString.indexOf(allowedStrings.API) !== -1) {
        return true;
      } else {
        return false;
      }
    }

    return {
      isStringValid: isStringValid,
      isApiCall: isApiCall
    };
  }
})();
